/**
 * @generated SignedSource<<9867152da22be68abe32ff0418c014b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CoachProgramsFolderRouteQuery$variables = Record<PropertyKey, never>;
export type CoachProgramsFolderRouteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CoachProgramsFoldersScreen_root">;
};
export type CoachProgramsFolderRouteQuery = {
  response: CoachProgramsFolderRouteQuery$data;
  variables: CoachProgramsFolderRouteQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachProgramsFolderRouteQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CoachProgramsFoldersScreen_root"
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CoachProgramsFolderRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProgramFolder",
        "kind": "LinkedField",
        "name": "programFolders",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eb16542b1d5c41d381f60f3548d74dbb",
    "id": null,
    "metadata": {},
    "name": "CoachProgramsFolderRouteQuery",
    "operationKind": "query",
    "text": "query CoachProgramsFolderRouteQuery {\n  ...CoachProgramsFoldersScreen_root\n}\n\nfragment CoachProgramsFoldersScreen_root on Root {\n  programFolders {\n    id\n    name\n    ...ProgramFolderCard_folder\n  }\n}\n\nfragment ProgramFolderCard_folder on ProgramFolder {\n  id\n  name\n}\n"
  }
};

(node as any).hash = "9f0549cb6c3931acea0b36c26d6153bb";

export default node;
